import { ITableHeaderComponentProps } from "@/interfaces/Table";
import { faPlus, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ElementRef, FC, useRef } from "react";
import { Button, Col, FormControl, InputGroup, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import StoreCompanyCourseStatusModal from "../modals/company/StoreCompanyCourseStatusModal";
import IconButton from "@/components/atoms/IconButton";

const AllCompanyCourseStatusesHeader: FC<ITableHeaderComponentProps> = ({
  onQueryChange,
}) => {
  const StoreCompanyCourseStatusModalRef =
    useRef<ElementRef<typeof StoreCompanyCourseStatusModal>>(null);

  const openCreateModal = () =>
    StoreCompanyCourseStatusModalRef.current?.showOrHiddenModal();

  return (
    <div className="d-lg-flex justify-content-between">
      <StoreCompanyCourseStatusModal
        ref={StoreCompanyCourseStatusModalRef}
        title="Ajouter un statut de formation"
      />
      <Row className="flex-between-center gy-2 px-x1">
        <Col xs="auto" className="pe-0">
          <h6 className="mb-0">Statuts de formation</h6>
        </Col>
        <Col xs="auto">
          <InputGroup className="position-relative input-search-width">
            <FormControl
              size="sm"
              id="search"
              type="search"
              className="shadow-none"
              placeholder="Rechercher"
              onChange={(e) => onQueryChange(e.target.value)}
            />
            <Button
              size="sm"
              variant="outline-secondary"
              className="border-300 hover-border-secondary"
            >
              <FontAwesomeIcon icon={faSearch} />
            </Button>
          </InputGroup>
        </Col>
      </Row>
      <div className="border-bottom border-200 my-3"></div>
      <div className="d-flex align-items-center justify-content-between justify-content-lg-end px-x1">
        <div id="orders-actions">
          <IconButton
            variant="nolina-default"
            size="sm"
            icon={faPlus}
            transform="shrink-3"
            iconAlign="middle"
            onClick={openCreateModal}
            className="mx-2"
          >
            <span className="d-none d-sm-inline-block d-xl-none d-xxl-inline-block ms-1">
              Nouveau
            </span>
          </IconButton>
        </div>
      </div>
    </div>
  );
};

export default AllCompanyCourseStatusesHeader;
